<template>
    <div class="bg-white mt-3 progress-status-view activity-type-create col-12" :style="themeColor">
        <b-modal id="modal-customer-user" header-class="p-0" footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap" @ok="handleOk" :style="themeColor">
            <template #modal-header="{ cancel }">
                <div class="title-block text-center p-2">
                    {{ !!userModel.hash ? $translate('edit_user') : $translate("add_user") }}
                </div>
                <button class="close" @click="cancel()">x</button>
            </template>
            <template #default>
                <b-form ref="contactForm" @submit.stop.prevent="handleSubmit">
                    <b-row>
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $translate('email') }}<span class="red">{{
                                userModel.is_blacklisted
                                ? '' : '*'
                            }}</span></strong></label>
                            <b-form-input id="input-email" v-custom-validation="$emailRequired()" v-model="displayEmail"
                                type="email" :placeholder="$translate('enter_email')" :required="isEmailViewOnly ||
                                    !userModel.is_blacklisted
                                    " :disabled="!isEmailViewOnly && !!userModel.id
        "></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">

                            <div class="d-flex align-items-center justify-content-end flex-row-reverse gap-2">
                                <label for="input-is_blacklisted" class="mt-0 mt-md-2"><strong>{{
                                    $translate('customer_portal_access') }}</strong></label>
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <b-form-checkbox id="input-is_blacklisted" v-model="is_blacklisted"
                                            name="input-is_blacklisted" :value="false" :unchecked-value="true"
                                            :disabled="isDummyEmail">
                                        </b-form-checkbox>
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('phone') }}</strong></label>

                            <b-form-input id="input-phone" v-model="userModel.phone" type="number"
                                :placeholder="$translate('enter_phone')"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('first_name') }}<span
                                        class="red">*</span></strong></label>
                            <b-form-input id="input-2" v-model="userModel.first_name"
                                :placeholder="$translate('enter_first_name')" v-custom-validation="$textRequired()"
                                required></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('last_name') }}<span
                                        class="red">*</span></strong></label>
                            <b-form-input id="input-last-name" v-model="userModel.last_name"
                                :placeholder="$translate('enter_last_name')" v-custom-validation="$textRequired()"
                                required></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('dob') }}</strong></label>
                            <b-form-input id="input-last-name" :max="dobCalender" type="date"
                                v-model="userModel.dob"></b-form-input>
                        </b-col>
                        <b-col class="mt-3 dd" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-2"><strong> {{ $translate('role') }}<span class="red">*</span></strong></label>
                            <b-form-select class="form-control" id="input-role_id" required :disabled="isDisabled"
                                v-model="userModel.portal_role_id" :options="portalRoles" text-field="name" value-field="id"
                                trim>
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_role')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('position') }}</strong></label>
                            <b-form-input id="input-position" v-model="userModel.position"
                                :placeholder="$translate('enter_position')"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('remarks') }}</strong></label>
                            <b-form-textarea id="input-remarks" v-model="userModel.remarks"
                                :placeholder="$translate('enter_remarks')" rows="3" max-rows="6"></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-form>
            </template>
            <template #modal-footer="{ ok, cancel }">
                <b-button v-if="!!userModel.id && hasPermissionUpdate" size="fw" variant="info"
                    @click="isEmailViewOnly = !isEmailViewOnly">
                    {{ isEmailViewOnly ? $cancelLabel() : $translate('change_email') }}
                </b-button>
                <b-button :disabled="loading" variant="info" size="fw" @click="ok()">
                    {{ customerSubmitLabel }}
                </b-button>
                <b-button size="fw" v-if="!isEmailViewOnly &&
                    !!userModel.hash" variant="delete-button" @click="deleteUser(userModel.hash)">
                    {{ $deleteLabel() }}
                </b-button>
                <b-button size="fw" variant="info" @click="
                    isEmailViewOnly = false
                cancel()
                    " v-if="!isEmailViewOnly">
                    {{ $cancelLabel() }}
                </b-button>
            </template>
        </b-modal>
        <b-col class="mt-1 text-right">
            <b-button type="submit" class="btn btn-info btn-fw me-2" @click="viewCustomer()" variant="primary">{{
                $translate('add_user') }}</b-button>
        </b-col>
        <b-col class="overflow-auto w-100 mt-4">
            <div class="table-responsive">
                <table class="table b-table" :style="customColor">
                    <thead>
                        <th v-for="item in fields" :key="item.id">{{ item.label }}</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in contacts" :key="item.id">
                            <td aria-colindex="1">
                                <b-button @click="viewCustomer(item, index)" class="mr-2" variant="pink-button">
                                    <img src="@/assets/images/icon/view.svg" />
                                </b-button>
                            </td>
                            <td>{{ item.first_name }}</td>
                            <td aria-colindex="2">
                                {{ item.last_name }}
                            </td>
                            <td aria-colindex="2">
                                {{ item.email }}
                            </td>
                            <td aria-colindex="2">
                                {{ getroleName(item.portal_role_id) }}
                            </td>
                            <td aria-colindex="2">
                                {{ item.phone }}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </b-col>
        <b-col class="mt-5 text-center">
            <b-button type="submit" @click="prevStep()" class="btn btn-info btn-fw me-2 " variant="primary">{{
                $translate('previous') }}</b-button>
            <b-button type="submit" @click="submitForm()" :disabled="submitting ? true : false"
                class="btn btn-info btn-fw me-2 " variant="primary">{{ submitLabel }}</b-button>
        </b-col>
    </div>
</template>
<script>
import moment from 'moment'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

const userModel = Object.freeze({
    first_name: null,
    last_name: null,
    is_blacklisted: 1,
    portal_role_id: null,
    email: null,
    phone: null,
    id: null,
    remarks: null,
})
export default {
    name: 'customerUsers-contacts',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            userModel: {
            },
            // submitting: false,
            isDisabled: false,
            loading: false,
            hasErrors: false,
            portalRoles: [
                { id: 1, name: 'Account Admin' },
                { id: 2, name: 'Regular User' },
                { id: 3, name: 'No Access' }
            ]
        }
    },
    props: ['value', 'submitting', 'themeColor'],
    computed: {
        dobCalender() {
            return moment().subtract(18, 'years').format('YYYY-MM-DD')
        },
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + "!important",
                color: data.text_color + "!important"
            }
            return colors
        },
        fields() {
            const { dummyEmailSuffix } = this
            return [
                { label: this.$translate('actions'), key: 'actions' },
                { label: this.$translate('first_name'), key: 'first_name' },
                { label: this.$translate('last_name'), key: 'last_name' },
                {
                    key: 'email',
                    label: this.$translate('email'),
                    formatter: value =>
                        (value || '').indexOf(dummyEmailSuffix) >= 0
                            ? ''
                            : value,
                },
                {
                    key: 'portal_role_id',
                    label: this.$translate('role'),
                    formatter: value =>
                        this.getroleName(value)
                },
                { label: this.$translate('phone'), key: 'phone' },
            ]
        },
        dummyEmailSuffix() {
            console.log('emailPartsValue:', this.emailPartsValue)
            const { emailDomain, usernameSuffix } = {
                ...(this.emailPartsValue || {}),
            }
            return `-${usernameSuffix}@${emailDomain}`
        },
        emailPartsValue() {
            return this.$store.getters['company/emailPartsValue']
        },

        emailPartsKey() {
            return this.$store.state.company.settingKeys.emailPartsKey
        },

        is_blacklisted: {
            set(value) {
                this.$set(this.userModel, 'is_blacklisted', value ? 1 : 0)
            },
            get() {
                return this.isDummyEmail
                    ? true
                    : !!this.userModel.is_blacklisted
            },
        },
        displayEmail: {
            set(value) {
                this.$set(this.userModel, 'email', value)
            },
            get() {
                const {
                    isDummyEmail,
                    userModel: { email },
                    isEmailViewOnly,
                } = this
                return isDummyEmail && isEmailViewOnly
                    ? ''
                    : isDummyEmail
                        ? '------'
                        : email
            },
        },
        submitLabel() {
            if (this.submitting) {
                console.log()
                return this.$translate('submitting')
            } else {
                return this.$translate('submit')
            }
        },
        customerSubmitLabel() {
            if (this.loading && this.userModel.hash) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.userModel.hash) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        isDummyEmail() {
            return (
                (this.userModel.email || '').indexOf(this.dummyEmailSuffix) >= 0
            )
        },
        model: {
            get() {
                console.log('', this.value)
                return this.value
            },
        },
        contacts() {
            return this.$store.state.customers.items
        },
    },
    watch: {
        contacts: {
            immediate: true,
            handler: function () {

            },
            deep: true,
        },
    },
    mounted() {
        this.$root.$on('bv::modal::show', () => {
            this.isEmailViewOnly = false
            console.log()
            if (this.contacts.length == 0) {
                this.$set(this.userModel, 'portal_role_id', 1)
            }
        })
    },
    methods: {
        getroleName(role_id) {
            const roleData = this.portalRoles.find(x => x.id == role_id)
            return roleData && roleData.name
        },
        viewCustomer(data, index) {
            console.log("index", index)
            if (index == 0) {
                this.isDisabled = true
            } else if (this.contacts.length == 0) {
                this.isDisabled = true
            } else {
                this.isDisabled = false
            }
            this.userModel = { ...userModel, ...(data || {}) }
            this.$bvModal.show('modal-customer-user')
        },
        checkFormValidity() {
            const valid = this.$refs.contactForm.checkValidity()
            return valid
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            ///this.handleSubmit()
            this.$refs.contactForm.requestSubmit()
        },
        submitForm() {
            this.$emit('submitForm'); // Emit the custom event
        },
        prevStep() {
            this.$emit('prev-clicked'); // Emit the custom event
        },
        deleteUser(hash) {
            const title = this.$translate('delete_customer')
            const message = `${this.$translate('delete_note')} ${this.$translate("customer")}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store.dispatch('customers/deleteContact', hash)
                    this.doToast(this.$translate('user_delete_alert'), this.$translate('deleted'), 'danger')
                    this.$bvModal.hide('modal-customer-user')
                }
            })
        },
        async handleSubmit() {
            try {
                if (!this.checkFormValidity()) {
                    throw new Error('Not Validated!')
                }
                const {
                    userModel: data,
                    isDummyEmail,
                    isEmailViewOnly,
                } = this
                const isNew = !data.hash
                console.log('dataaaa', this.customer)

                if (isEmailViewOnly) {
                    const { id: userId, email } = data
                    await this.$store.dispatch('users/updateEmail', {
                        userId,
                        email,
                    })
                    await this.$store.dispatch(
                        'customers/fetchById',

                    )
                } else {
                    if (isDummyEmail) {
                        data.is_blacklisted = 1
                    }

                    console.log('data', data)
                    if (data.is_blacklisted && !data.email) {
                        data.email = this.calculateDummyEmailAddress()
                    }
                    const path = `customers/merge`
                    this.loading = true
                    await this.$store.dispatch(path, {
                        data,
                    })
                }

                if (isNew) {
                    this.doToast(this.$translate('created'), this.$translate('user_create_alert'), 'success')
                } else {
                    this.doToast(this.$translate('updated'), this.$translate('user_update_alert'), 'success')
                }

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-customer-user')
                })
            } catch (error) {
                const emailError = this.$translate('data_was_invalid')
                if (error.response) {
                    // Request made and server responded
                    console.log('error.response')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                    this.doToast(
                        this.$translate('error'),
                        error.response.data.message,
                        'danger'
                    )
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log('error.request')
                    console.log(error.request)
                    this.doToast(
                        this.$translate('system_error_detected'),
                        this.$translate('contact_administrator'),
                        'danger'
                    )
                } else {
                    // Something happened in setting up the request that triggered an Error
                    let errorMessage = error.message

                    if (errorMessage == emailError) {
                        errorMessage = this.$translate('email_already_used')
                    }
                    console.log('Error', error.message)
                    this.doToast(this.$translate('error'), errorMessage, 'danger')
                }
            } finally {
                this.loading = false
            }
        },
        calculateDummyEmailAddress() {
            const username =
                Math.random().toString(36).substring(2, 15) +
                Math.random().toString(36).substring(2, 15)
            return `${username}-${this.dummyEmailSuffix}`
        },
    },
}
</script>
<style></style>
